const attributes = {
  name: 'name',
  src: 'src',
  width: 'width',
  height: 'height',
};

export default class Icon extends HTMLElement {
  #rootElement;
  #isSvg = false;
  #initialized = false;

  static get observedAttributes() {
    return Object.values(attributes);
  }

  constructor() {
    super();
  }

  connectedCallback() {
    if (this.#initialized) {
      return;
    }

    const src = this.getAttribute(attributes.src);

    if (src && src.trim()) {
      this.#isSvg = true;
      this.#rootElement = document.createElement('img');
      this.#rootElement.src = src;
      this.#rootElement.alt = this.getAttribute(attributes.name) || '';

      const width = this.getAttribute(attributes.width);
      const height = this.getAttribute(attributes.height);

      if (width) {
        this.#rootElement.style.width = width;
      }
      if (height) {
        this.#rootElement.style.height = height;
      }
    } else {
      this.#rootElement = document.createElement('i');
      const name = this.getAttribute(attributes.name);
      if (name && name.trim()) {
        this.#rootElement.classList.add(...name.split(' ').filter((cls) => cls.trim()));
      }
    }

    this.appendChild(this.#rootElement);
    this.#initialized = true;
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (!this.#initialized) {
      return;
    }

    if (name === attributes.name && !this.#isSvg) {
      this.updateName(newValue, oldValue);
    } else if (name === attributes.src && this.#isSvg && this.#rootElement) {
      this.#rootElement.src = newValue;
    } else if (name === attributes.width && this.#isSvg && this.#rootElement) {
      this.#rootElement.style.width = newValue;
    } else if (name === attributes.height && this.#isSvg && this.#rootElement) {
      this.#rootElement.style.height = newValue;
    }
  }

  updateName(newValue, oldValue) {
    if (!this.#rootElement) {
      return;
    }
    if (oldValue && oldValue.trim()) {
      this.#rootElement.classList.remove(...oldValue.split(' ').filter((cls) => cls.trim()));
    }
    if (newValue && newValue.trim()) {
      this.#rootElement.classList.add(...newValue.split(' ').filter((cls) => cls.trim()));
    }
  }
}

customElements.define('sjwc-icon', Icon);
